// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slice--thumbnail-with-description .cell--content[data-v-66bde11c] section h2:first-child,.slice--thumbnail-with-description .cell--content[data-v-66bde11c] section h3:first-child{margin-top:0}.slice--thumbnail-with-description .cell--content[data-v-66bde11c] section p:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
